import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { GuestCounter } from 'sarsaparilla';
import RenderIf from '../../utils/JSXUtils';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  title: PropTypes.string,
  groups: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    type: PropTypes.string,
    description: PropTypes.string
  })).isRequired,
  counts: PropTypes.objectOf(PropTypes.number),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  inline: PropTypes.bool
};

const defaultProps = {
  inline: false
};

export default class SimpleGuestCounter extends PureComponent {
  constructor(props) {
    super(props);
    this.onCountsChanged = this.onCountsChanged.bind(this);
  }

  onCountsChanged(counts) {
    this.props.onChange(counts);
  }

  render() {
    const { id, label, inline, title, counts, groups, className } = this.props;
    const wrapClass = inline ? 'rec-form-inline-item' : 'rec-form-item-wrap';
    const classes = `${wrapClass} ${className}`;

    return (
      <div className={classes}>
        {RenderIf(label)(<label htmlFor={id}>{label}</label>)}
        <GuestCounter
          id={id}
          title={title}
          value={counts}
          guestTypes={groups}
          onCountChange={this.onCountsChanged} />
      </div>
    );
  }
}

SimpleGuestCounter.propTypes = propTypes;
SimpleGuestCounter.defaultProps = defaultProps;
